import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { TokenStorageService } from '../token-storage.service';

/**
 * Permission-gated routes (C28/V209): `data: { requiresPermission: '…' }`.
 *
 * Kapı izne bakar, rol adına değil. İzni olmayan doğrudan URL yazarsa
 * oturumun başlangıç sayfasına döner (pano ya da garson/mutfak ekranı). Bu sadece görünürlük; asıl kilit backend'de (V204, V208).
 */
@Injectable({ providedIn: 'root' })
export class PermissionGuard implements CanActivate {
  constructor(
    private tokenStorage: TokenStorageService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const required = route.data['requiresPermission'];
    if (typeof required === 'string' && this.tokenStorage.hasPermission(required)) {
      return true;
    }
    return this.router.parseUrl(this.tokenStorage.landingUrl());
  }
}
